import { Box, Divider, useTheme } from '@mui/material';
import TradeOptionsCard from 'app/components/TradeIdeas/TradeOptions';
import PageHeader from 'app/design/speedBot/PageHeader';
import CircularLoader from 'app/design/uiComponents/CircularLoader';
import { Helmet } from 'react-helmet-async';
import useGetInstruments from 'services/Bots/useGetInstruments';
import useGetTradeIdeasMetaData from 'services/TradeIdeas/useGetTradeIdeadsMetaData';
import { GetInstrumentsResult } from 'types/Instrument';

const TradeOptions = () => {
  const { data: metaData } = useGetTradeIdeasMetaData();
  const theme = useTheme();
  const { data: instruments } = useGetInstruments(`exchange=NFO&type=all`);
  return (
    <Box>
      <CircularLoader open={false} zIndex={1302} />
      <Helmet>
        <title>Trade Ideas</title>
        <meta name="description" content="TradeIdeas Page" />
      </Helmet>
      <Box
        className="sticky-top"
        sx={{ backgroundColor: theme.palette.common.white }}
      >
        <PageHeader variant={'common'} title={'Trade Ideas'} />
        <Divider sx={{ borderBottom: 2, borderColor: 'grey.300' }} />
      </Box>
      <Box bgcolor={theme.component.mainLayoutContainer.main}>
        {metaData?.metadata &&
          Object.keys(metaData.metadata).map((symbol, index) => {
            return (
              metaData.metadata[symbol] && (
                <TradeOptionsCard
                  key={index}
                  selectedSymbol={symbol}
                  description={metaData.metadata[symbol].description}
                  expiry={metaData.metadata[symbol].expiry}
                  instruments={instruments || ({} as GetInstrumentsResult)}
                />
              )
            );
          })}
      </Box>
    </Box>
  );
};

export default TradeOptions;
